<template>
  <div class="page h-100">
    <div class="container pt-70">
      <div class="flex align-center mb-70">
        <el-image :src="Utils.formatImg(brandInfo.photo)" fit="contain" class="brand-logo mr-30"></el-image>
        <div class="flex-1">
          <div class="flex align-end mb-14">
            <div class="font-40 color-ff font-yahei">{{brandInfo.name}}</div>
            <div class="font-16 font-yahei color-c19357 ml-20 mb-4">共{{total}}个在售商品</div>
          </div>
          <div class="font-16 font-yahei color-ca">{{brandInfo.profile}}</div>
        </div>
      </div>
      <div class="menu flex">
        <div class="flex-1 flex-column justify-center">
          <div class="flex align-start">
            <img src="/images/xuanxiang-leibie.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">分类</div>
            <div class="line"></div>
            <div class="flex flex-1 flex-wrap w-0">
              <button class="menu-item font-12" :class="categoryIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'categoryIndex')">不限</button>
              <button class="menu-item font-12" :class="categoryIndex === index ? 'active' : ''" v-for="(item, index) in categoryList" :key="index" @click="chooseMenu(index, 'categoryIndex')">{{item.name}}</button>
            </div>
          </div>
          <div class="hr-dashed"></div>
          <div class="flex align-start">
            <img src="/images/xuanxiang-fengge.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">风格</div>
            <div class="line"></div>
            <div class="flex flex-1 flex-wrap w-0">
              <button class="menu-item font-12" :class="styleIndex === -1 ? 'active' : ''" @click="chooseMenu(-1, 'styleIndex')">不限</button>
              <button class="menu-item font-12" :class="styleIndex === index ? 'active' : ''" v-for="(item, index) in styleList" :key="index" @click="chooseMenu(index, 'styleIndex')">{{item.name}}</button>
            </div>
          </div>
          <!-- <div class="hr-dashed"></div>
          <div class="flex align-center">
            <img src="/images/xuanxiang-gengduo.png" alt="" class="mr-10">
            <div class="font-16 color-292a2e font-yahei">系列</div>
            <div class="line"></div>
            <button class="menu-item font-12" :class="seriesIndex === '' ? 'active' : ''" @click="chooseMenu(index, 'seriesIndex')">不限</button>
            <button class="menu-item font-12" :class="seriesIndex === index ? 'active' : ''" v-for="(item, index) in seriesList" :key="index" @click="chooseMenu(index, 'seriesIndex')">{{item.name}}</button>
          </div> -->
        </div>
      </div>
      <div class="flex align-center mb-30">
        <img src="/images/weizhi.png" alt="" class="mr-10">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index.html' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/brand.html' }">找品牌</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>现代轻奢</el-breadcrumb-item>
          <el-breadcrumb-item>Monitto品牌店</el-breadcrumb-item> -->
          <el-breadcrumb-item>共{{total}}个商品</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="hr mb-10"></div>
      <div class="flex align-center sort mb-30">
        <button class="font-12 cursor" :class="isSales === '' && isPrice === '' ? 'color-c19357' : 'color-94'" @click="onSort('')">综合排序</button>
        <div class="line"></div>
        <button class="flex align-center font-12 cursor" :class="isSales !== '' ? 'color-c19357' : 'color-94'" @click="onSort('isSales')">
          销量
          <img :src="isSales === 1  ? '/images/paixu-jiangxu.png' : isSales === 0 ? '/images/paixu-shengxu.png' : '/images/paixu.png'" class="ml-5">
        </button>
        <div class="line"></div>
        <button class="flex align-center font-12 cursor" :class="isPrice !== '' ? 'color-c19357' : 'color-94'" @click="onSort('isPrice')">
          价格
          <img :src="isPrice === 1  ? '/images/paixu-jiangxu.png' : isPrice === 0 ? '/images/paixu-shengxu.png' : '/images/paixu.png'" class="ml-5">
        </button>
      </div>
      <div class="flex flex-wrap mb-40">
        <goods-item v-for="(item, index) in goodsList" :goodsItem="item" :key="index" :index="index" :isDiscount="index%6 === 0"></goods-item>
      </div>
      <el-pagination layout="prev, pager, next" :page-size="16" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import GoodsItem from '@/components/GoodsItem'
export default {
  name: 'brandDetail',
  components: {GoodsItem},
  computed: {},
  data () {
    return {
      styleList: [],
      categoryList: [],
      seriesList: this.Utils.series,
      styleIndex: -1,
      categoryIndex: -1,
      seriesIndex: '',
      isSales: '',
      isPrice: '',
      brandInfo: {},
      keywords: '',
      page: 1,
      limit: 16,
      total: 0,
      goodsList: []
    }
  },
  created () {
  },
  mounted () {
    this.id = this.$route.query.id.slice(0,-5)
    if (this.id) {
      this.getData()
    }
    this.getCategory()
    this.getStyle()
    this.getGoods()
  },
  methods: {
    getData () {
      this.axios.post('brand/getById', this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.brandInfo = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
     getCategory () {
      this.axios.post('category/list', {}).then(res => {
        if (res.data.success) {
          this.categoryList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getStyle() {
      this.axios
        .post("style/list",{})
        .then(res => {
          if (res.data.success) {
            this.styleList = res.data.data;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              offset: 400
            });
          }
        });
    },
    getGoods () {
      this.goodsList = []
      let params = {
        brandId: this.id,
        styleId: this.styleIndex >=0 ? this.styleList[this.styleIndex].id : '',
        category: this.categoryIndex >=0 ? this.categoryList[this.categoryIndex].name : '',
        keywords: this.keywords,
        limit: this.limit,
        page: this.page
      }
      this.axios.post(`goods/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.goodsList = res.data.data.list
          this.total = res.data.data.total
        }
      })
    },
    handleCurrentChange (e) {
      console.log(e)
      this.page = e
      this.getGoods()
    },
    chooseMenu (e, key) {
      this[key] = e
      this.getGoods()
    },
    onSort (key) {
      if (!key) {
        this.isSales = ''
        this.isPrice = ''
      } else {
        switch (this[key]) {
          case '':
            this.isSales = ''
            this.isPrice = ''
            this[key] = 1
          break
          case 1:
            this[key] = 0
          break
          case 0:
            this[key] = 1
        }
      }
    },
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
  .page{
    background: #eeeff3 url('/images/pinpaixiangqingbg.png') no-repeat top center/auto 335px;
    padding-bottom: 105px;
  }
  .brand-logo{
    width: 90px;
    height: 90px;
    overflow: hidden;
    border-radius: 50%;
  }
  .menu{
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 30px 70px 0px rgba(41, 42, 46, 0.07);
    margin-bottom: 32px;
    padding: 30px;
    .line{
      height: 24px;
      width: 1px;
      background: #e9e9e9;
      margin: 0 20px;
    }
    .menu-item{
      padding: 0 10px;
      height: 20px;
      line-height: 20px;
      border-radius: 10px;
      color: #7d7d7d;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 5px;
    }
    .active{
      background: #f6efe6;
    }
    .hr-dashed{
      width: 100%;
      height: 1px;
      border-bottom: 1px dashed #e9e9e9;
      margin: 16px 0;
    }
  }
  .sort{
    .line{
      width: 1px;
      height: 12px;
      background: #e9e9e9;
      margin: 0 20px;
    }
    button {
      padding: 0;
    }
  }
</style>
